import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getUser, check_uri_permission } from './Common';

function PrivateRoute({ component: Component, ...rest }) {

    if (!getUser()) {
        return (
            <Route
                {...rest}
                render={(props) => <Redirect to={{ pathname: '/login', state: { from: props.location } }} />}
            />
        );
    }

    if (!check_uri_permission(rest.path) && !['/dashboard', '/'].includes(rest.path)) {
        return (
            <Route
                {...rest}
                render={(props) => <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />}
            />
        );
    }

    return (
        <Route
            {...rest}
            render={(props) => <Component {...props} />}
        />
    );
}



export default PrivateRoute;